const mTheHeaderSubMenuDropDownUser = {
  mTheHeaderSubMenuDropDownUser: {
    options: {
      account: 'Datos de Perfil',
      language: 'Cambiar de Idioma',
      logout: 'Cerrar Sesión',
      security: 'Seguridad',
      shopping: 'Mis Compras'
    }
  }
}

export default mTheHeaderSubMenuDropDownUser
